<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CollaboratorShow from "@/views/pages/collaborators/profile/show/show";
import SSOSitesCard from "@/components/sso/SSOSitesCard.vue";

export default {
  components: {
    Layout,
    PageHeader,
    CollaboratorShow,
    SSOSitesCard
  },
  data() {
    return {
      title: "Inicio",
    };
  },
  computed:{
    isCollaborator() {
      return this.$store.getters['permission/isCollaborator']();
    },
  },
  methods: {
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div v-if="isCollaborator">
      <CollaboratorShow></CollaboratorShow>
    </div>
    
    <div v-else>
      <!-- Welcome Section -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="text-center py-4">
                <i class="ri-dashboard-line display-4 text-primary mb-3"></i>
                <h4>Gestiona la configuración de tu perfil</h4>
                <p class="text-muted">
                  Configura tu perfil de Carné Joven según tus preferencias
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- SSO Sites Card -->
      <div class="row">
        <div class="col-12">
          <SSOSitesCard 
            variant="large"
            title="Navega por nuestros sitios"
            description="Explora todas las plataformas que tenemos para ti"
            :show-footer="true"
            :is-centered="false"
          />
        </div>
      </div>
    </div>
  </Layout>
</template>